import React from 'react';
const SvgSignalCellular0Bar = (props) => {
    return (<svg viewBox='0 0 24 24' fill='currentColor' className='svg-icon' {...props}>
			<path d='M0 0h24v24H0V0z' fill='none'/>
			<path d='M2 22h20V2L2 22zm18-2H6.83L20 6.83V20z'/>
		</svg>);
};
export default SvgSignalCellular0Bar;
